<template>
  <v-container fluid class="ma-0 pa-0">
    <v-layout>
    <v-flex>
      <v-img
        src="././img/tmp/bg1.webp"
        min-height="260"
        max-height="260"
        alt="Handwerker BG"
        dark
        lazy-src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAICAgICAgICAgIDAgICAwQDAgIDBAUEBAQEBAUGBQUFBQUFBgYHBwgHBwYJCQoKCQkMDAwMDAwMDAwMDAwMDAz/2wBDAQMDAwUEBQkGBgkNCgkKDQ8ODg4ODw8MDAwMDA8PDAwMDAwMDwwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCABUACYDAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/9k="
      >
      <v-container>
        <v-layout row>
          <v-flex xs12 lg10 offset-lg1 xl8 offset-xl2>
            <h3 style="padding-top: 80px;" :class="ÜberschriftSize" class="font-weight-medium white--text"><span class="font-weight-light">Mitwirkende</span> Kreishandwerkerschaften</h3>
          </v-flex>  
        </v-layout>
      </v-container>
 
      </v-img>
    </v-flex>
    </v-layout>
  <v-container>
    <v-layout class="mt-4">
    <v-flex xs12 lg10 offset-lg1 xl8 offset-xl2>
    <v-layout row wrap grid-list-lg v-if="this.khs">
      <div v-for="kh in this.khs" :key="kh.id" class="text-truncate">
        <v-btn large dark color="light-blue darken-4" class="ma-1"
          :to="{ name: 'khdetail', params: { id: kh.slug }}"
          :disabled="!kh.slug">
            <span class="subheading text-none font-weight-medium">
              {{ kh.name.substr(22) }}
            </span>
        </v-btn>
      </div>
    </v-layout>
    <v-layout row wrap class="my-5 px-1 font-weight-thin" :class="InfoSize" >
      <v-flex xs12 class="mt-3">
        Kreishandwerkerschaften sind die <strong>lokalen Vertretungen der Innungen</strong> auf Ebene der Landkreise. 
      </v-flex>
      <v-flex xs12 class="mt-5">
        Sie führen die <strong>Geschäfte der Innungen</strong> und sind kümmern sich häufig um die <strong>Ausbildung der Lehrlinge</strong>. 
      </v-flex>
      <!-- <v-flex xs12 class="mt-4">
        Sie <strong>vertreten die Interessen</strong> der Innungsbetriebe gegenüber den weiteren Akteuren innerhalb der Landkreise. 
      </v-flex> -->
      <v-flex xs12 class="mt-5">
        <strong>Schlichtungsstellen</strong> der Innungen vermitteln oftmals in Streitfällen, ohne den kostspieligen Rechtsweg erforderlich zu machen. 
      </v-flex>
    </v-layout>
    </v-flex>
  </v-layout>
  </v-container>
  </v-container>
</template>
  

<script>
import axios from 'axios'

export default {
  data: () => ({
    show: false,
    dialog: false,
    isLoading: false,
    betriebe: [],
    khs: []
  }),
  components: {
  },
  mounted () {
    this.getKHs()
  },
  metaInfo () {
    return {
      meta: [
        { name: 'description', content: 'Kreishandwerkerschaften sind der Ansprechpartner für alle Aspekte runs ums Handwerk auf lokaler Ebene und setzen sich für Qualität und Neutralität ein.' }
      ] }
  },
  computed: {
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'display-1'
      } else {
        return 'display-3'
      }
    },
    InfoSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'headline'
      } else {
        return 'display-1'
      }
    }
  },
  methods: {
    getKHs: function () {
      this.isLoading = true
      const self = this
      axios.get('/api/v1/kreishandwerkerschaften').then(response => {
        // console.log(response)
        self.khs = response.data
        self.isLoading = false
      })
    .finally(() => {
      self.isLoading = false
    })
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      return text.substring(0, length) + suffix
    }
  }
}
</script>


<style>
</style>